import { createSlice } from "@reduxjs/toolkit";

function parseLocalStorageItem(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

const initialState = {
  isAuthenticated: !!localStorage.getItem("token"),
  isVerified: false,
  imageQr: "",
  isGenerateQr: false,
  user: parseLocalStorageItem("user", {}),
  userImageBase64: null,
  loading: false,
  error: null,
  token: localStorage.getItem("token") || null,
  flagChangePassword: parseLocalStorageItem("flagChangePassword", false),
  permissions: [],
  expiredIn: parseLocalStorageItem("expiredIn", 0),
  timeLeft: parseLocalStorageItem("timeLeft", 0),
  lastLogin: parseLocalStorageItem("lastLogin", null),
  captchaImage: parseLocalStorageItem("captchaImage", null),
};

export const Auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    ChangeAuth: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    ChangeUser: (state, action) => {
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.user = action.payload;
    },
    ChangeImageBase64: (state, action) => {
      state.userImageBase64 = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeError: (state, action) => {
      state.error = action.payload;
    },
    ChangeToken: (state, action) => {
      localStorage.setItem("token", action.payload);
      state.token = action.payload;
    },
    ChangeOTP: (state, action) => {
      state.isVerified = action.payload;
    },
    ChangeImageQr: (state, action) => {
      state.imageQr = action.payload;
    },
    ChangeGenerateQr: (state, action) => {
      state.isGenerateQr = action.payload;
    },
    ChangeFlagChangePassword: (state, action) => {
      localStorage.setItem("flagChangePassword", action.payload);
      state.flagChangePassword = action.payload;
    },
    ChangePermissions: (state, action) => {
      state.permissions = action.payload;
    },
    Logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("flagChangePassword");
      localStorage.removeItem("timeLeft");
      localStorage.removeItem("expiredIn");
      localStorage.removeItem("expiresAtComment");
      state.isAuthenticated = false;
      state.isVerified = false;
      state.user = {};
      state.token = null;
      state.imageQr = "";
      state.isGenerateQr = false;
      state.userImageBase64 = null;
    },
    ChangeLastLogin: (state, action) => {
      const currentUser = state.user;
      currentUser.lastLogin = action.payload;

      localStorage.setItem("user", JSON.stringify(currentUser));
      state.user = currentUser;
    },
    ChangeExpireIn: (state, action) => {
      localStorage.setItem("expiredIn", action.payload);
      state.expiredIn = action.payload;
    },
    ChangeTimeLeft: (state, action) => {
      localStorage.setItem("timeLeft", action.payload);
      state.timeLeft = action.payload;
    },
    ChangeDataLastLogin: (state, action) => {
      const lastLoginData = action.payload;
      
      localStorage.setItem("lastLogin", JSON.stringify(lastLoginData));
      state.lastLogin = lastLoginData;
    },
    ChangeCaptchaImage: (state, action) => {
      localStorage.setItem("captchaImage", action.payload);
      state.timeLeft = action.payload;
    },
  },
});

export const {
  ChangeAuth,
  ChangeUser,
  ChangeImageBase64,
  ChangeLoading,
  ChangeError,
  ChangeToken,
  ChangeOTP,
  ChangeImageQr,
  ChangeGenerateQr,
  ChangeFlagChangePassword,
  ChangePermissions,
  Logout,
  ChangeLastLogin,
  ChangeExpireIn,
  ChangeDataLastLogin,
  ChangeCaptchaImage
} = Auth.actions;

export default Auth.reducer;
